import Notifications from '@kyvg/vue3-notification'

export default Notifications